/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */
const original = require('../../../../packages/design-system/navigation-system/src/entry-points/layout/side-nav.tsx');

module.exports = Object.assign({}, original, {
	SideNavContent: original.SideNavBody,
});

if (original.__esModule) Object.defineProperty(module.exports, '__esModule', { value: true });
